import Label from '@components/atoms/label';

type SelectBoxSize = 'default' | 'compact';

type SelectBoxType = {
  name: string;
  label: string;
  onChange: (val) => void;
  options: { [key: string]: string | number }[];
  value: string | number;
  disabled?: boolean;
  // "compact" sits the control on the 38px / 14px-label baseline used by
  // filter rows; "default" keeps the original sizing.
  size?: SelectBoxSize;
};

const LABEL_CLASS_BY_SIZE: Record<SelectBoxSize, string> = {
  default: 'text-base mb-1',
  compact: 'text-sm mb-1.5'
};

const SELECT_CLASS_BY_SIZE: Record<SelectBoxSize, string> = {
  default: 'mt-1 py-2 text-base',
  compact: 'h-[38px] py-0 text-sm'
};

const SelectBox = ({
  name,
  label,
  onChange,
  options = [],
  value = '',
  disabled = false,
  size = 'default'
}: SelectBoxType) => {
  return (
    <div className="relative">
      <Label
        htmlFor={name}
        className={`flex text-neutral-800 ${LABEL_CLASS_BY_SIZE[size]}`}
      >
        {label}
      </Label>
      <select
        value={value}
        id={name}
        name={name}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full rounded-md border border-gray-300 bg-white px-3 font-normal shadow-sm focus:outline-none focus:ring-transparent ${SELECT_CLASS_BY_SIZE[size]}`}
      >
        {options.map((option, index) => {
          return (
            <option
              key={index}
              disabled={disabled}
              value={option.value}
              className="font-normal "
            >
              {option.label}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default SelectBox;
